'use strict'

window._ = require 'underscore'
require '../../../src/frontend/vendor/md5'
require '../../../src/frontend/vendor/cookie'
require '../groupon_modules/modernizr-hacks'
I18n = require '../../../node_modules/grapefruit/lib/I18n'
options = $(document.head).data()
window.I18n = new I18n(options)
require 'optimize-suite' # pwa file - has dependencies to md5 and Cookie.js
# the reason cart has been moved here is that hoganJS only exists in the core file
require '../../../src/frontend/vendor/eventPause-custom'
require 'jquery.finger'
initHistoryEvent = require './history_events'

{Optimize} = window
{config} = Optimize.suiteData
config.finch = config: Optimize.finchConfig
Optimize.config = config
OptimizeSuite.init config
initHistoryEvent(window.history)



// WEBPACK FOOTER //
// ./core/frontend/common/core_libraries.coffee